import { createFileRoute } from "@tanstack/react-router";

import { CaseNewPage } from "@/features/cases/case-new-page";
import { STATIC_LABELS } from "@/lib/nav-registry";

// ロールガードは親 layout (`enterprise/route.tsx`) が ENTERPRISE 限定。
export const Route = createFileRoute("/_authenticated/enterprise/new")({
  staticData: { crumb: { label: STATIC_LABELS.enterpriseNew } },
  component: CaseNewPage,
});
